const CoreCompetencies = () => {
    return (
        <div className="CoreCompetencies">
            <h3>Core Competencies</h3>
            <div className="competencies">
                <div className="competency">
                    <span>Banking and Finance</span>
                    <b>Tier 1</b>
                </div>
                <div className="competency">
                    <span>Corporate / M&A</span>
                    <b>Tier 1</b>
                </div>
                <div className="competency">
                    <span>Real Estate</span>
                    <b>Tier 1</b>
                </div>
                <div className="competency">
                    <span>Energy</span>
                    <b>Tier 1</b>
                </div>
                <div className="competency">
                    <span>
                        Litigation and Dispute Resolution
                    </span>
                    <b>Tier 1</b>
                </div>
            </div>
        </div>
    );
};

export default CoreCompetencies;
